export * from './lib/contact-form.component';
